import type { ReactNode } from "react";

interface Props {
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
}

export function Topline({ left = "COMPANION", right, className = "" }: Props) {
  return (
    <div className={`flex items-baseline justify-between editorial-topline ${className}`}>
      <span className="text-ink opacity-80">{left}</span>
      {right != null && <span className="text-accent">{right}</span>}
    </div>
  );
}
